import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  checkbox: {
    padding: 0,
    paddingRight: "11px",
  },
}));
